<div class="points-rescue">
  <h2 class="title">{{labels.title}}</h2>
  <div class="points-rescue-content">
    <p>{{labels.description}}</p>
    <div class="rescue-codes">
      <div *ngFor="let pointCodeFormGroup of form.controls; let i = index">
        <div class="input-container">
          <app-select id="select-equipment-input-{{i}}"
                      [control]="getControlFromTuple(i, 'equipment')"
                      appearance="fill"
                      [options]="options"
                      [label]="labels.selectEquipment"
                      [value]="options[0]"
                      required>
          </app-select>
          <app-code-input codeInput
                          id="code-input-{{i}}"
                          [control]="getControlFromTuple(i, 'code')"
                          [hasCloseButton]="hasCloseButton()"
                          (closeButtonClick)="deleteCode(i)"
                          [subscript]="getPointsCodeSubscript(i)"
                          points>
          </app-code-input>
        </div>
      </div>
    </div>
    <div class="add-tuple">
      <app-icon-button id="add-more-codes" 
                       icon="add_box"
                       type="submit"
                       (clickAction)="addCodes()"
                       [disabled]="hasReachedMaxInput()">
        {{labels.addMoreCodes}}
      </app-icon-button> 
    </div>
    <app-label *ngIf="pointQuantity" isBig>
      {{pointTotalLabel}}
    </app-label>
    <app-primary-button id="rescue-code"
                        [abstractControl]="form"
                        (clickAction)="rescue()"
                        [disabled]="rescueLoading"
                        class="rescue-button">
      {{labels.rescueCode}}
    </app-primary-button>
  </div>
</div>
